import z from 'zod';

export const CompletePartialPaymentSchema = z.object({
  referenceNumber: z.string(),
  contributionCurrency: z.string(),
  contributionAmount: z.number().max(1000000).nonnegative('Contribution amount must be positive'),
  paymentMethod: z.enum(['debit_credit', 'manual_payment']),
});
